// 获取地址栏中参数
export function getUrlQuery() {
  let sHref = window.location.href
  let args = sHref.split('?')
  if (args[0] === sHref) { return '' }
  let arr = args[1].split('&')
  let obj = {}
  for (let i = 0; i < arr.length; i++) {
    let arg = arr[i].split('=')
    obj[arg[0]] = arg[1]
  }
  return obj
}

// 加密
export const encrypt = (encryptCode) => {
  let codeList = encryptCode.split('')
  for(let i = 0; i < codeList.length; i++){
    codeList[i] += Math.floor( Math.random() * 10)
  }
  return codeList.join('')
}

// 解密
export const decrypt = (decryptCode) => {
  let codeList = decryptCode.split('')
  let decryptWord = ''
  for(let i = 0; i < codeList.length; i++){
    if(i % 2 === 0){
      decryptWord += codeList[i]
    }
  }
  return decryptWord
}